export default [
    {
        path: '/activity/jobFair',
        component: () =>
            import('../../views/activity/jobFair-country/index'),
        meta: {
            title: '专题首页-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/employment-guidance',
        component: () =>
            import('../../views/activity/jobFair-country/employment-guidance'),
        meta: {
            title: '职位推荐-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/policy',
        component: () =>
            import('../../views/activity/jobFair-country/policy'),
        meta: {
            title: '就业政策-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/ranking',
        component: () =>
            import('../../views/activity/baijiaRank.vue'),
        meta: {
            title: '百家企业排名-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/empolypolicy',
        component: () =>
            import('../../views/activity/employment-policy/index.vue'),
        meta: {
            title: '全国残疾人高校毕业生就业创业政策汇总-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/empolypolicy/list',
        component: () =>
            import('../../views/activity/employment-policy/list.vue'),
        meta: {
            title: '全国残疾人高校毕业生就业创业政策汇总-河北省就业创业服务平台',
            // requireAuth: true,
            // userType: 2
        },
    },
    {
        path: '/activity/activity-volunteer',
        component: () =>
            import('../../views/activity/activity-volunteer/index.vue'),
        meta: {
            title: '全国助残日-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/activity-volunteer/list',
        component: () =>
            import('../../views/activity/activity-volunteer/list.vue'),
        meta: {
            title: '全国助残日-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/activity-volunteer/typicalList',
        component: () =>
            import('../../views/activity/activity-volunteer/typicalList.vue'),
        meta: {
            title: '全国助残日-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/baiqiang',
        component: () =>
            import('../../views/activity/baiqiang/index.vue'),
        meta: {
            title: '2022年优秀残疾人就业典范宣传活动-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/activityNew',
        component: () =>
            import('../../views/activity/activityNew/index.vue'),
        meta: {
            title: '2022年优秀残疾人就业宣传年-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
    {
        path: '/activity/quarter-jobFair',
        component: () =>
            import('../../views/activity/quarter-jobFair/jobFair'),
        meta: {
            title: '2025年河北省残疾人季度招聘会专区-河北省就业创业服务平台',
            requireAuth: true,
            userType: 2
        },
    },
]
